import React, { useRef, useState } from 'react'
import { Icon } from '@iconify/react'
import LimitReachedModal from 'src/components/limit-reached-modal'
import CreateCourseMenu from './create-course-menu'
import CreateCourseModal from './create-course-modal'
import useCreateCourseFlow from './useCreateCourseFlow'
import useStyles from './styles'

export {
  default as CreateCourseMenu,
  CREATE_OPTIONS,
} from './create-course-menu'
export { default as CreateCourseModal } from './create-course-modal'
export { default as useCreateCourseFlow } from './useCreateCourseFlow'

/**
 * Create course trigger with its dropdown (Create from scratch / AI Course
 * Builder).
 * - variant "head": the Courses page header button
 * - variant "path": "Create new course" in a learning path's Courses tab
 */
const CreateCourseButton = ({
  variant = 'head',
  label,
  pathId,
  pathName,
  onTrack,
}) => {
  const classes = useStyles()
  const triggerRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const flow = useCreateCourseFlow({ pathId })

  const handleSelect = option => {
    setMenuOpen(false)
    if (onTrack) onTrack(option)
    flow.select(option)
  }

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className={variant === 'head' ? classes.headButton : classes.pathButton}
        onClick={() => setMenuOpen(open => !open)}
      >
        <Icon
          icon="tabler:sparkles"
          width={variant === 'head' ? 16 : 14}
          height={variant === 'head' ? 16 : 14}
        />
        {label || (variant === 'head' ? 'Create course' : 'Create new course')}
        <Icon icon="tabler:chevron-down" width={14} height={14} />
      </button>

      <CreateCourseMenu
        anchorEl={menuOpen ? triggerRef.current : null}
        align={variant === 'head' ? 'right' : 'left'}
        onClose={() => setMenuOpen(false)}
        onSelect={handleSelect}
      />

      <CreateCourseModal
        open={flow.scratchOpen}
        pathId={pathId}
        pathName={pathName}
        onClose={flow.closeScratch}
        onBack={() => {
          flow.closeScratch()
          setMenuOpen(true)
        }}
      />

      {flow.limitModalOpen && (
        <LimitReachedModal
          isModalOpen={flow.limitModalOpen}
          handleCloseModal={flow.closeLimitModal}
        />
      )}
    </>
  )
}

export default CreateCourseButton
